import { Phone, MapPin, ArrowDown } from "lucide-react";
import { COMPANY, MEDIA } from "../lib/constants";

// Kept here as direct import avoided for simplicity; used by JLServiceLanding
export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden bg-[#0F213A]"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={MEDIA.hero}
          alt="Eksklusiv træterrasse med spa bygget af JL Service"
          className="w-full h-full object-cover"
          loading="eager"
        />
        {/* Overlay: dark blue gradient from left to transparent right for legibility */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F213A]/95 via-[#0F213A]/75 to-[#0F213A]/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F213A]/70 via-transparent to-transparent md:hidden" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 min-h-[100svh] flex flex-col justify-center pt-24 pb-16">
        <div className="max-w-2xl fade-up">
          {/* Location chip */}
          <div className="inline-flex items-center gap-2 border border-white/25 px-3 py-1.5 mb-8 backdrop-blur-sm bg-white/5">
            <MapPin size={14} className="text-white/80" />
            <span className="text-white/90 text-xs uppercase tracking-[0.25em] font-semibold">
              {COMPANY.city} · Østjylland
            </span>
          </div>

          <h1
            data-testid="hero-heading"
            className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white leading-[1.05]"
          >
            Din lokale handyman i {COMPANY.city} —{" "}
            <span className="text-white/70 block sm:inline">
              professionelt håndværk til fair priser.
            </span>
          </h1>

          <p
            data-testid="hero-subheading"
            className="mt-6 text-base md:text-lg text-white/80 leading-relaxed max-w-xl"
          >
            Fra små reparationer i hjemmet til eksklusive træterrasser.{" "}
            <span className="text-white font-semibold">JL Service</span>{" "}
            klarer opgaven — med fokus på finish, fair priser og et håndtryk
            der holder.
          </p>

          {/* CTAs */}
          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href={`tel:${COMPANY.phoneRaw}`}
              data-testid="hero-call-btn"
              className="group inline-flex items-center justify-center gap-3 bg-white text-[#0F213A] px-8 py-5 text-base font-black uppercase tracking-[0.15em] btn-lift"
            >
              <Phone size={20} strokeWidth={2.5} />
              Ring nu: {COMPANY.phone}
            </a>
            <a
              href="#kontakt"
              data-testid="hero-contact-btn"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/40 text-white hover:bg-white hover:text-[#0F213A] px-8 py-5 text-base font-bold uppercase tracking-[0.15em] transition-colors"
            >
              Send forespørgsel
            </a>
          </div>

          {/* Trust bar */}
          <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg border-t border-white/15 pt-6">
            <Stat value="15+" label="års erfaring" />
            <Stat value="100%" label="lokal · Hammel" />
            <Stat value="Fair" label="gennemsigtige priser" />
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <a
        href="#services"
        aria-label="Scroll ned"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-white/70 hover:text-white hidden md:flex items-center gap-2 text-xs uppercase tracking-[0.3em]"
      >
        <ArrowDown size={16} className="animate-bounce" />
        Scroll
      </a>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="text-white text-2xl md:text-3xl font-black tracking-tight">
        {value}
      </div>
      <div className="text-white/60 text-[11px] uppercase tracking-[0.2em] mt-1 font-semibold">
        {label}
      </div>
    </div>
  );
}
